import { createColumnHelper } from '@tanstack/react-table'
import { NavLink } from 'react-router-dom'
import formate from 'date-format'
import ActionButton from '../../components/shared/ActionButton'
import { ViewIcon } from '../../components/shared/Icons'

const columnHelper = createColumnHelper()

/**
 * 格式化报价类型显示文案。
 * @param {string} quoteType 报价类型
 * @returns {string} 类型文案
 */
export const formatQuoteType = (quoteType) => {
  const labels = {
    standard_pcb: 'Standard PCB',
    advanced_pcb: 'Advanced PCB',
    fpc_rigid_flex: 'FPC/Rigid-Flex',
    assembly: 'Assembly',
    smd_stencil: 'SMD-Stencil',
    cnc_3d: 'CNC/3D',
  }
  return labels[quoteType] || quoteType || '-'
}

/**
 * 渲染报价状态标签。
 * @param {string} status 报价状态
 * @returns {JSX.Element} 状态标签
 */
export const QuoteStatusBadge = ({ status }) => {
  const statusColors = {
    draft: 'bg-gray-100 text-gray-700',
    calculated: 'bg-blue-100 text-blue-700',
    submitted: 'bg-orange-100 text-orange-700',
    approved: 'bg-green-100 text-green-700',
    rejected: 'bg-red-100 text-red-700',
    ordered: 'bg-purple-100 text-purple-700',
  }

  return (
    <span className={`rounded px-2 py-1 text-xs ${statusColors[status] || 'bg-gray-100 text-gray-700'}`}>
      {status || '-'}
    </span>
  )
}

export const columns = [
  columnHelper.accessor('quoteNo', {
    header: 'Quote No',
    cell: (info) => info.getValue() || '-',
  }),
  columnHelper.accessor('quoteType', {
    header: 'Quote Type',
    cell: (info) => formatQuoteType(info.getValue()),
  }),
  columnHelper.accessor('customerInfo', {
    header: 'Customer',
    cell: (info) => info.getValue()?.name || info.row.original?.user?.name || '-',
  }),
  columnHelper.accessor('customerInfo.email', {
    header: 'Email',
    cell: (info) => info.getValue() || info.row.original?.user?.email || '-',
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    cell: (info) => <QuoteStatusBadge status={info.getValue()} />,
  }),
  columnHelper.accessor('pricing.totalAmount', {
    header: 'Total',
    cell: (info) => `$${Number(info.getValue() || 0).toFixed(2)}`,
  }),
  columnHelper.accessor('pricing.shippingMethod', {
    header: 'Shipping',
    cell: (info) => info.getValue() || '-',
  }),
  columnHelper.accessor('reviewFlags', {
    header: 'Review Flags',
    cell: (info) => (info.getValue() || []).join(', ') || '-',
  }),
  columnHelper.accessor('createdAt', {
    header: 'Created At',
    cell: (info) => formate.asString('dd/MM/yyyy', new Date(info.getValue())),
  }),
  columnHelper.accessor('orderId', {
    header: 'Order Linked',
    cell: (info) => (info.getValue()?._id ? 'Yes' : 'No'),
  }),
  columnHelper.accessor('_id', {
    id: 'View',
    header: <span className="opacity-0">View</span>,
    cell: (info) => (
      <NavLink to={`/quotes/view/${info.getValue()}`}>
        <ActionButton>
          <ViewIcon />
          View
        </ActionButton>
      </NavLink>
    ),
  }),
]
